import React, { FC, MouseEvent, useEffect, useState } from "react"
import { InfoBoxOptions } from "./InfoBox.types"

import "./InfoBox.scss"

const InfoBox: FC<InfoBoxOptions> = ({
    label,
    children,
    className,
    onClick,
    ...htmlProps
}: InfoBoxOptions) => {
    const [show, setShow] = useState(false)
    const [iconPath, setIconPath] = useState("#zb-icon-chev-down-xsmall")

    useEffect(() => {
        const iconClass = `zb-icon-chev-${show ? "up" : "down"}-xsmall`
        setIconPath(`${iconClass}`)
    }, [show])

    const toggle = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        e.stopPropagation()
        setShow((s) => !s)
        onClick && onClick(e)
    }

    const klass = `zb-info-box ${className || ""}`

    return (
        <>
            <div className={klass} {...htmlProps}>
                <button
                    type="button"
                    className="zb-tertiary-cta zb-info-box-trigger"
                    onClick={toggle}
                    aria-expanded={show}
                >
                    <span>{label}</span>
                    <svg
                        focusable="false"
                        aria-hidden="true"
                        className={`${iconPath} zb-icon`}
                    >
                        <use xlinkHref={`#${iconPath}`}></use>
                    </svg>
                </button>
                {show && <div className="zb-info-box-content">{children}</div>}
            </div>
        </>
    )
}

export default InfoBox
